module.exports = __webpack_public_path__ + "static/img/real3.fc5998f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/resources/images/demo/real3.jpg
// module id = /jeA
// module chunks = 1